const getPercent = (placed, gain) => {
  const roundedA = Math.round((placed + Number.EPSILON) * 100) / 100;
  const roundedB = Math.round((gain + Number.EPSILON) * 100) / 100;
  return (roundedB * 100) / roundedA - 100;
};

export default getPercent;
